export const worldCup2026PageIds = [
	'football/world-cup-2026',
	'football/world-cup-2026/fixtures',
	'football/world-cup-2026/overview',
	'football/australia',
];

export const worldCupTagId = 'football/world-cup-2026';
